export function formatUsd(v: number | null | undefined): string {
  if (v === null || v === undefined) return '—'
  return `$${v < 0.01 && v > 0 ? v.toFixed(4) : v.toFixed(2)}`
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`
  return `${(n / 1024 ** 3).toFixed(2)} GB`
}

export function formatDateTime(ts: number, locale: string): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(ts)
}

/**
 * "in 2 hours" / "3 days ago", localised by the same locale as the rest of the page. Used next to an
 * absolute timestamp, never instead of one: the relative half is what makes "soon" visible at a glance.
 */
export function formatRelative(ts: number, locale: string, now = Date.now()): string {
  const diff = ts - now
  const abs = Math.abs(diff)
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  if (abs < 60_000) return rtf.format(Math.round(diff / 1000), 'second')
  if (abs < 3_600_000) return rtf.format(Math.round(diff / 60_000), 'minute')
  if (abs < 86_400_000) return rtf.format(Math.round(diff / 3_600_000), 'hour')
  return rtf.format(Math.round(diff / 86_400_000), 'day')
}
